import { GeneralConfigModel } from "shared/api/superadmin/api";

const DEFAULT_TOP_HEADER_CONFIG = {
  title: "",
  searchTextPlaceholder: "Search",
  tenantIconSvg: "",
};

export const TOP_HEADER_CONFIG_KEY = "topHeader";

export const DEFAULT_GENERAL_CONFIG: GeneralConfigModel = {
  mileageUnit: "km",
  helpContactEmail: "",
  rootPage: "",
  rootPageMobile: "",
  metabaseDashboards: [],
  signalEventsTimelineResponseLimit: null,
  timezone: "UTC",
  topHeader: DEFAULT_TOP_HEADER_CONFIG,
  distanceUnit: "mi",
  temperatureUnit: "°F",
  pressureUnit: "psi",
  voltageUnit: "V",
  percentageUnit: "%",
  frequencyUnit: "rpm",
  timeUnit: "h",
  currentUnit: "mA",
  energyUnit: "microWh",
  angleUnit: "°",
  speedUnit: "mph",
  currencyUnit: "$",
  language: "English",
  languageCode: "en-US",
  dateTimeFormat: null,
};
